import { InstagramData, useAnalytics, WidgetProps, InstagramConfig } from "@commons-monorepo/index";
import { FC } from "react";
import WidgetContainer from "../../../widget-container";
import styles from "./instagram-skin-2.module.css";
import Carousel from "../../../carousel/carousel";
import { useTranslation } from "react-i18next";
import { UiButton } from "@ui-monorepo/components";
import CaretRight from "@sumerkit/icons/caret-right/ssr";

type SliderArrowPropsInstagramSkin2 = {className?: string;onClick?: () => void;};

const InstagramSkin2: FC<WidgetProps<InstagramData[], InstagramConfig>> = ({
  id,
  data,
  config,
  theme,
  storeMetadata
}) => {
  const { t } = useTranslation();
  const INSTAGRAM_URL = `https://www.instagram.com/${config?.username}`;
  const [logEvent] = useAnalytics({ storeMetadata });

  const SliderArrow = ({ className, onClick }: SliderArrowPropsInstagramSkin2) => {
    return (
      <UiButton
        isBlack
        appearance='icon'
        className={className || ""}
        leftIcon={<CaretRight />}
        onClick={onClick}
        theme={theme} />);


  };
  const SettingInstagramSkin2 = {
    dots: false,
    speed: 500,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    variableWidth: false,
    prevArrow: <SliderArrow />,
    nextArrow: <SliderArrow />,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]

  };

  const log = (option: string) => {
    logEvent("select_button", {
      event_subtype: "instagram_posts",
      user_type: "buyer",
      platform: "web",
      option
    });
  };

  const highLightBackground = config?.highlight_background;

  return (
    <WidgetContainer
      id={id}
      className={styles.widgetContainer}
      containerClassName={styles.widgetContainerContent}
      highlight={!!highLightBackground}>

      <div className={styles.instagramSkin2Container}>
        <a
          href={INSTAGRAM_URL}
          target={"_blank"}
          onClick={() => {
            log("text_link");
          }}
          rel='noreferrer'>

          <h3 className={styles.instagramSkin2Title}>
            {t("instagram.follow_in")} @{config?.username ? config?.username : "instagram.store"}
          </h3>
        </a>
        <div className={`${styles.instagramSkin2Carousel}`}>
          <Carousel {...SettingInstagramSkin2}>
            {data?.slice(1).map((item, index) =>
            <a
              key={`${index}-instagram-skin-2`}
              href={data && data[0]?.postUrl}
              target={"_blank"}
              className={styles.instagramSkin2Card}
              onClick={() => {
                log("post");
              }}>

                <div className={styles.instagramSkin2ContainerCard}>
                  {data && data[0]?.isVideo && <figure className={`${styles.reelIcon} icon-play`} />}
                  <figure className={`${styles.instagramIcon} icon-instagram-circle-outline`} />
                  <img src={item.displayUrl} alt={`Imagen secundaria ${index + 1}`} />
                </div>
              </a>
            )}
          </Carousel>
        </div>
      </div>
    </WidgetContainer>);

};

export default InstagramSkin2;